import React from "react";

import FormSvg from "../../assets/images/icons/forms-blue.svg";

export const FormBlueIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={FormSvg}
        alt={alt || "Form"}
    />
);
